import { Div } from 'ui';

import defaultAvatar from 'assets/ProfilePic.svg';


const SIZES = {
  small: 32,
  medium: 40,
  large: 48,
  full: '100%'
}

const Avatar = ({
  id,
  src,
  className,
  size = 'medium'
}) => {

  const avatar = src || defaultAvatar

  return (
    <Div
      borderRadius={12}
      overflow='hidden'
      width={SIZES[size]}
      height={SIZES[size]}
      className={className}
    >
      <img
        width='100%'
        height='100%'
        id={id}
        src={avatar}
        alt=""
      />
    </Div>
  )
}

export default Avatar;